export default "__VITE_ASSET__c61941f1__"